import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, IDR } from "@/lib/api";

const Card = ({ label, value, testid }) => (
  <div className="border border-[color:var(--border)] p-6" data-testid={testid}>
    <div className="text-[10px] tracking-widest text-neutral-500">{label}</div>
    <div className="display text-4xl mt-2">{value}</div>
  </div>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-neutral-500">Memuat...</div>;
  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="display text-4xl md:text-6xl">DASHBOARD</h1>
        <div className="flex flex-wrap gap-2 text-[10px] tracking-widest">
          <span data-testid="mode-payment" className={`status-badge ${s.payment_mode === "midtrans" ? "" : "bg-[color:var(--accent)] text-white border-transparent"}`}>PAY: {String(s.payment_mode).toUpperCase()}</span>
          <span data-testid="mode-email" className="status-badge">EMAIL: {s.email_enabled ? "ON" : "OFF"}</span>
          <span data-testid="mode-storage" className="status-badge">STORAGE: {s.storage_enabled ? "CLOUD" : "LOCAL"}</span>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card label="ORDERS TODAY" value={s.orders_today} testid="stat-orders-today" />
        <Card label="REVENUE TODAY" value={IDR(s.revenue_today)} testid="stat-revenue-today" />
        <Card label="PENDING PAYMENTS" value={s.pending_payments} testid="stat-pending" />
        <Card label="PAID ORDERS" value={s.paid_orders} testid="stat-paid" />
        <Card label="IN PRODUCTION" value={s.orders_in_production} testid="stat-prod" />
        <Card label="READY TO SHIP" value={s.ready_to_ship} testid="stat-ready" />
        <Card label="UNANSWERED Q" value={s.unanswered_questions} testid="stat-questions" />
      </div>
      <div className="mt-8">
        <div className="text-[10px] tracking-widest text-neutral-500 mb-3">QUICK ACTIONS</div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          <Link to="/admin/products/new" data-testid="qa-new" className="border border-[color:var(--border)] p-4 hover:bg-white hover:text-black transition-colors text-xs tracking-widest">+ ADD PRODUCT</Link>
          <Link to="/admin/import" data-testid="qa-import" className="border border-[color:var(--border)] p-4 hover:bg-white hover:text-black transition-colors text-xs tracking-widest">IMPORT CSV</Link>
          <Link to="/admin/orders" data-testid="qa-orders" className="border border-[color:var(--border)] p-4 hover:bg-white hover:text-black transition-colors text-xs tracking-widest">VIEW ORDERS</Link>
          <Link to="/admin/production" data-testid="qa-prod" className="border border-[color:var(--border)] p-4 hover:bg-white hover:text-black transition-colors text-xs tracking-widest">PRODUCTION QUEUE</Link>
          <Link to="/admin/questions" data-testid="qa-q" className="border border-[color:var(--border)] p-4 hover:bg-white hover:text-black transition-colors text-xs tracking-widest">QUESTIONS</Link>
        </div>
      </div>
    </div>
  );
}
